import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetTraceabilityApi } from '../api/traceability/get_traceability.ts';

export const fetchTraceabilityAsync = createAsyncThunk(
    'traceability/fetchTraceability',
    async (filters) => {
        const { document, start_date, end_date } = filters;
        const response = await GetTraceabilityApi(document, start_date, end_date);
        return response;
    }
);

const traceabilitySlice = createSlice({
    name: 'traceability',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchTraceabilityAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchTraceabilityAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchTraceabilityAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export default traceabilitySlice.reducer;